module.exports = __webpack_public_path__ + "static/media/logo-reduzida.ba2d2c75.png";